import React from "react";
import { Input } from "../../../../shared/ui/controls/Input/Input";
import { FieldWrapper } from "../../../../shared/ui";
import { FilterBar } from "../../../../shared/ui/layouts/FilterBar";
import {
  toTimeManagementFiltersForm,
  useTimeManagementFiltersParams,
} from "../../../../features/time-management";
import type { TimeManagementFiltersForm } from "../../../../features/time-management";
import { timeManagementColumns } from "../model/constants";
import { TimeEntryCategorySelect } from "../../../../entities/time-entry";

export const TimeManagementFilterBar: React.FC = () => {
  const [params, setParams] = useTimeManagementFiltersParams();
  const filters = toTimeManagementFiltersForm(params);

  const updateField = (field: keyof TimeManagementFiltersForm, value: string) => {
    void setParams({ ...filters, [field]: value });
  };

  const handleSortChange = (sortKey: string, direction: string) => {
    void setParams({
      ...filters,
      sortField: sortKey as TimeManagementFiltersForm["sortField"],
      sortDirection: direction as TimeManagementFiltersForm["sortDirection"],
    });
  };

  return (
    <FilterBar columns={timeManagementColumns}>
      <FieldWrapper label="Handwerker">
        <Input
          as="input"
          value={filters.technicianName}
          onChange={(value) => updateField("technicianName", value)}
          placeholder=""
        />
      </FieldWrapper>
      <FieldWrapper label="Kategorie">
        <TimeEntryCategorySelect
          value={filters.category}
          onChange={(value) => void setParams({ ...filters, category: value })}
          withAllOption
          className="!min-h-[40px] h-[40px]"
        />
      </FieldWrapper>

      <FieldWrapper
        label="Von"
        sortKey="startTime"
        activeSortField={filters.sortField}
        sortOrder={filters.sortDirection}
        onSortChange={handleSortChange}
      >
        <Input
          as="input"
          value={filters.dateFrom}
          onChange={(value) => updateField("dateFrom", value)}
          placeholder=""
          type="date"
        />
      </FieldWrapper>

      <FieldWrapper
        label="Bis"
        sortKey="endTime"
        activeSortField={filters.sortField}
        sortOrder={filters.sortDirection}
        onSortChange={handleSortChange}
      >
        <Input
          as="input"
          value={filters.dateTo}
          onChange={(value) => updateField("dateTo", value)}
          placeholder=""
          type="date"
        />
      </FieldWrapper>
    </FilterBar>
  );
};
